function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgArrow = function SvgArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 13.492 14.289"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    stroke: "#a0f",
    d: "M.75 7.138v-2.67c0-3.31 2.35-4.67 5.22-3.01l2.31 1.34 2.31 1.34c2.87 1.66 2.87 4.37 0 6.03l-2.31 1.34-2.31 1.34c-2.87 1.63-5.22.28-5.22-3.04v-2.67z"
  }));
};
export default SvgArrow;